function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ImageProcess } from "./image";
var cnameMapping = _defineProperty(_defineProperty(_defineProperty({}, 'firefly-resource', "res.i-firefly.com"), 'firefly-beast', "o.i-firefly.com"), 'firefly-asset', "a.i-firefly.com");
export var MediaBlobs;
(function (_MediaBlobs) {
  function link(blob) {
    var mimetype = blob.mimetype;
    var uri = Blobs.link(blob);
    if (mimetype === 'image/heic') {
      return ImageProcess.process(uri, {
        format: "jpg",
        quality: 80
      });
    }
    return uri;
  }
  _MediaBlobs.link = link;
})(MediaBlobs || (MediaBlobs = {}));
export var Blobs;
(function (_Blobs) {
  function link(blob) {
    var _cnameMapping$bucket;
    var bucket = blob.bucket,
      key = blob.key;
    var name = (_cnameMapping$bucket = cnameMapping[bucket]) !== null && _cnameMapping$bucket !== void 0 ? _cnameMapping$bucket : bucket;
    return "https://".concat(name, "/").concat(key);
  }
  _Blobs.link = link;
})(Blobs || (Blobs = {}));